export const GET_CHAT = 'GET_CHAT';
export const SET_CHAT = 'SET_CHAT';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const GET_CHAT_DETAILS = 'GET_CHAT_DETAILS';
export const SET_CHAT_DETAILS = 'SET_CHAT_DETAILS';
export const SYNC_CHAT_DETAILS = 'SYNC_CHAT_DETAILS';
export const STOP_SYNC = 'STOP_SYNC';

export interface ChatSummary {
  id: string;
  senderid: string;
}

export interface ChatMessage {
  id: string;
  message: string;
  senderid: string;
  timeadded: number;
}

export interface Sender {
  id: string;
  firstName: string;
  image: string;
}

export interface ChatProps {
  message: ChatMessage[];
  sender: Sender;
  id: string;
}

export interface Chat {
  chat: Array<ChatProps>;
  chatDetails?: ChatProps | undefined;
  isLoading: boolean;
}

export interface SendMessageProps {
  id?: string;
  message: string;
  receiver?: string;
}

export interface SendMessage {
  chat: SendMessageProps;
}

export interface GetChatAction extends Chat {
  type: typeof GET_CHAT;
}

export interface SetChatAction extends Chat {
  type: typeof SET_CHAT;
  chat: ChatProps[];
}

export interface GetChatDetailsAction extends Chat {
  type: typeof GET_CHAT_DETAILS;
  id: string;
}

export interface SetChatDetailsAction extends Chat {
  type: typeof SET_CHAT_DETAILS;
  chatDetails: ChatProps | undefined;
}

export interface SendMessageAction {
  type: typeof SEND_MESSAGE;
  chat: SendMessageProps;
}

export type ChatActionTypes =
  | GetChatAction
  | SetChatAction
  | GetChatDetailsAction
  | SetChatDetailsAction;
